import {
    select as D3select,
    dispatch as D3dispatch,
    scaleOrdinal as D3scaleOrdinal,
    bisector as D3bisector
} from 'd3';
import Moment from 'moment';
import D3AreaChart from './D3AreaChart';
import D3TimelineBrush from './D3TimelineBrush';

// combination timeline area chart with an axis with a time slider brush, and an overlay brush for zooming
const D3TimelineSlider = function () {
    const dispatch = D3dispatch('changed');

    // make room for axis and tooltips
    const margin = { top: 30, right: 0, bottom: 10, left: 10 };

    // overrides defaults
    let color = D3scaleOrdinal();
    let dataservice = {
        timestamp: d => d.timestamp,
        count: d => d.count
    };
    let height = 40;
    let width = 100;
    let start;
    let end;
    let selection = [Moment().subtract(1, 'h'), Moment()];

    function my (selction) {
        if (!selction) return;
        selction.each(function (data, i) {
            const brushHeight = 40;
            const areacHeight = height - margin.top - margin.bottom - brushHeight;
            const svg = D3select(this)
                .selectAll('svg')
                .data(['once'])
                .join('svg')
                .style('pointer-events', 'none')
                .attr('width', width)
                .attr('height', height);

            // these guys can both apply selections to each-other and to parent
            drawTimelineBrush(selection);

            // timeline brush
            function drawTimelineBrush (sel) {
                // render axis with brush
                svg.selectAll('g.timeline-brush')
                    .data([data])
                    .join('g')
                    .attr('class', 'timeline-brush')
                    .attr('transform', `translate(0, ${margin.top + areacHeight})`)
                    .call(D3TimelineBrush()
                        .dataservice(dataservice)
                        .color(color)
                        .width(width)
                        .height(brushHeight)
                        .sel(sel)
                        .start(start)
                        .end(end)
                        .on('changed', s => {
                            dispatch.call('changed', my, s);
                            drawSelectionAreaChart(s);
                        }));

                drawSelectionAreaChart(sel);
            }

            // area chart limited to current selection
            function drawSelectionAreaChart (sel) {
                const bisect = D3bisector(d => dataservice.timestamp(d)).left;
                const fdata = data.slice(bisect(data, sel[0]), bisect(data, sel[1]));

                svg.selectAll('g.timeline-area')
                    .data([fdata])
                    .join('g')
                    .attr('class', 'timeline-area')
                    .attr('transform', `translate(0, ${margin.top})`)
                    .call(D3AreaChart()
                        .dataservice(dataservice)
                        .color(color)
                        .width(width)
                        .height(areacHeight)
                        .start(sel[0])
                        .end(sel[1])
                        .on('changed', s => {
                            dispatch.call('changed', my, s);
                            drawTimelineBrush(s);
                        }));
            }
        });
    }

    my.width = function (v) {
        if (!arguments.length) return width;
        width = v;
        return my;
    };

    my.height = function (v) {
        if (!arguments.length) return height;
        height = v;
        return my;
    };

    my.dataservice = function (v) {
        if (!arguments.length) return dataservice;
        dataservice = v;
        return my;
    };

    my.color = function (v) {
        if (!arguments.length) return color;
        color = v;
        return my;
    };

    my.start = function (v) {
        if (!arguments.length) return start;
        start = v;
        return my;
    };

    my.end = function (v) {
        if (!arguments.length) return end;
        end = v;
        return my;
    };

    // incoming time selection
    my.selection = function (v) {
        if (!arguments.length) return selection;
        selection = v;
        return my;
    };

    my.on = function () {
        const value = dispatch.on.apply(dispatch, arguments);
        return value === dispatch ? my : value;
    };

    return my;
};

export default D3TimelineSlider;
